import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router';
import Fragment from 'react-dot-fragment';

import CheckIcon from '../../../../containers/assets/onboarding-check.png';

const Wrapper = styled.div`
  flex: 0 0 268px;
  background: #ffffff;
  padding: 40px 29px 40px 30px;;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-right: 1px solid #d5d9dd;
  align-self: stretch;
`;

const Line = styled.div`
  width: 1px;
  height: 16px;
  background: #2da548;
  margin-left: 10px;
`;

const Step = styled.div`
  font-family: 'Mukta Vaani';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);

  a:active, a:visited, a:link {
    color: rgba(0, 27, 59, 0.94);
  }

  img {
    margin-right: 9px;
    width: 21px;
    height: 21px;
  }
`;

const Navigation = ({
  data,
  category,
  activeRound
}) => {
  return (
    <Wrapper>
      {data.map((link, index) => {
        if (!!link.parent) {
          return null;
        }

        return (
          <Fragment key={`section-${index}`}>
            <Step>
              <img src={CheckIcon} alt="nav icon" />
              {index !== category && (
                <Link to={`${link.steps[0].url}?round=${activeRound}`}>{link.title}</Link>
              )}
              {(index === category) && link.title}
            </Step>
            {
              index < data.length - 1 &&
              <Line />
            }
          </Fragment>
        );
      })}
    </Wrapper>
  );
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/instructor/components/grading/components/navigation.js